import React from 'react';
import DashboardTableContainer from './DashboardTable/DashboardTable.container';
import DashboardTodayContainer from './DashboardToday/DashboardToday.container';
import DashboardChartContainer from './DashboardChart/DashboardChart.container';
import AggregationInfoChart from '../../AggregationInfoChart/AggregationInfoChart.container';
import PageHeading from '../../UI/blocks/PageHeading';
import { useI18n } from 'utils/I18n/context';

export default function DashboardPage() {
    const { t } = useI18n();
    const staticNames = t?.dashboard || {
        title: 'Dashboard',
        period: 'Period',
        lastPeriod: 'Last period',
    };

    return (
        <div className="dashboard">
            <PageHeading title={staticNames.title} />

            <AggregationInfoChart />

            <div className="period_wrapper">
                <h3>{staticNames.period}</h3>
                <DashboardTodayContainer />
            </div>

            <section className="wrapper-content" id="dashboardPage">
                <h3>{staticNames.lastPeriod}</h3>

                <div className="toolbar__view">
                    <span className="diagram" />
                    <span className="tile" />
                    <span className="table" />
                </div>

                <DashboardChartContainer />

                <div className="card dashboard-table-card">
                    <div className="card-body">
                        <DashboardTableContainer />
                    </div>
                </div>
            </section>
        </div>
    );
}
